import {customElement, property} from "lit/decorators.js";
import {css, html, LitElement} from "lit";

@customElement('logo-button-svg')
class LogoButtonSvg extends LitElement {
    @property()
    size = "2rem";
    @property()
    color = "var(--left-side-logo)";
    @property()
    viewBox = "0 0 37 40";

    protected render(): unknown {
        return html`
            <svg width="${this.size}" height="${this.size}" viewBox="0 0 512 512" fill="none" version="1.1" id="svg39"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:svg="http://www.w3.org/2000/svg">
                <g
                    clip-path="url(#clip0_3016_105442)"
                    id="g12"
                    transform="matrix(1.600005,0,0,1.4580082,-153.60048,-116.64066)">
                    <path
                        d="m 403.078,284.466 h -0.761 c -6.84,-0.761 -11.401,-6.081 -11.401,-12.922 v -3.801 c 0,-6.08 0.76,-12.161 0.76,-18.242 v -8.361 c 0,-3.04 0,-6.841 -0.76,-9.881 0,-6.841 4.561,-12.162 11.401,-12.922 6.841,-0.76 12.162,4.561 12.922,11.402 0,3.8 0,6.841 0.76,10.641 v 3.801 c 0,1.52 0,3.8 0,5.32 0,6.841 0,12.922 -0.76,19.763 v 4.56 c -0.76,6.081 -6.081,10.642 -12.161,10.642 z"
                        fill="url(#paint0_linear_3016_105442)"
                        id="path2"
                        style="fill:url(#paint0_linear_3016_105442)" />
                    <path
                        d="m 252.579,431.164 c -30.403,0 -57.007,-27.364 -72.969,-76.01 -2.28,-6.08 1.52,-12.921 7.601,-15.201 6.081,-2.281 12.922,1.52 15.202,7.6 12.162,36.485 31.164,59.288 50.166,59.288 30.404,0 63.848,-62.328 63.848,-151.259 0,-88.931 -33.444,-151.259 -63.848,-151.259 -19.002,0 -38.004,22.803 -50.166,60.048 -2.28,6.08 -9.121,9.881 -15.202,7.601 C 181.13,169.691 177.33,162.85 179.61,156.77 195.572,108.124 222.176,80 252.579,80 c 49.407,0 88.171,76.77 88.171,175.582 0,98.812 -38.764,175.582 -88.171,175.582 z"
                        fill="url(#paint1_linear_3016_105442)"
                        id="path4"
                        style="fill:url(#paint1_linear_3016_105442)" />
                    <path
                        d="m 361.274,333.872 c -0.761,0 -1.521,0 -3.041,0 -6.841,-1.52 -10.641,-7.601 -9.121,-14.442 4.561,-21.283 7.601,-44.846 7.601,-68.408 0,-20.523 -1.52,-41.046 -5.321,-60.048 -1.52,-6.841 3.041,-12.922 9.882,-14.442 6.84,-1.52 12.921,3.041 14.441,9.881 3.801,20.523 6.081,41.806 6.081,64.609 0,25.843 -2.28,50.926 -7.601,73.729 -2.28,5.32 -7.601,9.121 -12.921,9.121 z"
                        fill="url(#paint2_linear_3016_105442)"
                        id="path6"
                        style="fill:url(#paint2_linear_3016_105442)" />
                    <path
                        d="m 267.782,366.556 c -1.521,0 -3.041,0 -4.561,-0.76 -6.081,-2.281 -9.121,-9.121 -6.841,-15.962 10.641,-27.364 15.962,-60.048 15.962,-95.012 0,-34.965 -5.321,-67.649 -15.962,-95.012 -2.28,-6.081 0.76,-12.922 6.841,-15.962 6.081,-2.28 12.922,0.76 15.962,6.841 11.401,30.404 17.482,66.128 17.482,103.373 0,38.004 -6.081,73.729 -17.482,103.373 -2.28,6.08 -6.841,9.121 -11.401,9.121 z"
                        fill="url(#paint3_linear_3016_105442)"
                        id="path8"
                        style="fill:url(#paint3_linear_3016_105442)" />
                    <path
                        d="m 138.565,379.478 c -10.641,0 -17.482,-1.521 -18.242,-1.521 -3.8,-0.76 -7.601,-3.8 -9.121,-7.601 -1.52,-3.8 -0.76,-8.361 0.76,-11.401 11.401,-16.722 13.682,-28.124 14.442,-33.444 C 107.401,306.508 96,280.665 96,255.582 c 0,-40.285 26.603,-76.77 69.169,-95.772 19.002,-8.361 40.285,-12.922 61.567,-12.922 6.841,0 12.162,5.321 12.162,12.162 0,6.841 -5.321,12.161 -11.402,12.161 -18.242,0 -36.484,3.801 -51.686,10.642 -34.204,15.202 -54.727,42.565 -54.727,72.969 0,20.522 9.121,41.045 25.843,55.487 1.521,1.52 3.041,3.8 3.801,6.081 0.76,3.04 3.04,15.962 -7.601,38.764 12.161,-0.76 27.363,-3.8 35.724,-15.962 3.041,-3.8 7.601,-6.08 12.162,-4.56 7.601,1.52 28.883,6.081 37.245,6.081 6.84,0 12.161,5.32 12.161,12.161 0,6.841 -5.321,12.162 -12.161,12.162 -9.122,0 -25.084,-3.041 -34.965,-4.561 -16.722,15.962 -39.525,19.003 -54.727,19.003 z"
                        fill="var(--text-01)"
                        id="path10" />
                </g>
                <defs
                    id="defs37">
                    <linearGradient
                        id="paint0_linear_3016_105442"
                        x1="403.458"
                        y1="218.265"
                        x2="403.458"
                        y2="284.466"
                        gradientUnits="userSpaceOnUse">
                        <stop
                            offset="0.244792"
                            stop-color="#2970FF"
                            id="stop14" />
                        <stop
                            offset="1"
                            stop-color="#C60077"
                            id="stop16" />
                    </linearGradient>
                    <linearGradient
                        id="paint1_linear_3016_105442"
                        x1="259.846"
                        y1="80"
                        x2="259.846"
                        y2="431.164"
                        gradientUnits="userSpaceOnUse">
                        <stop
                            offset="0.244792"
                            stop-color="#2970FF"
                            id="stop19" />
                        <stop
                            offset="1"
                            stop-color="#C60077"
                            id="stop21" />
                    </linearGradient>
                    <linearGradient
                        id="paint2_linear_3016_105442"
                        x1="365.288"
                        y1="176.239"
                        x2="365.288"
                        y2="333.872"
                        gradientUnits="userSpaceOnUse">
                        <stop
                            offset="0.244792"
                            stop-color="#2970FF"
                            id="stop24" />
                        <stop
                            offset="1"
                            stop-color="#C60077"
                            id="stop26" />
                    </linearGradient>
                    <linearGradient
                        id="paint3_linear_3016_105442"
                        x1="276.144"
                        y1="143.091"
                        x2="276.144"
                        y2="366.556"
                        gradientUnits="userSpaceOnUse">
                        <stop
                            offset="0.244792"
                            stop-color="#2970FF"
                            id="stop29" />
                        <stop
                            offset="1"
                            stop-color="#C60077"
                            id="stop31" />
                    </linearGradient>
                    <clipPath
                        id="clip0_3016_105442">
                        <rect
                            width="320"
                            height="351.164"
                            fill="white"
                            transform="translate(96 80)"
                            id="rect34" />
                    </clipPath>
                </defs>
            </svg>
        `
    }
}
